import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { SubTitle } from './Title';

const ThumbnailContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
  gap: 10px;
  padding: 1rem 0;
`;

const ThumbnailImage = styled.img`
  height: 110px;
  width: 100%;
  overflow-y: auto;
  cursor: pointer;
  &:hover {
    transform: scale(1.1); 
    transition: transform 0.6s;
    z-index: 1;
  }
  ${({ highlighted }) => highlighted && `
    background-color: lightgreen; 
    border: 2px solid lightgreen;
  `}
`;

const ModalBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); 
  backdrop-filter: blur(5px); 
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  overflow-y: hidden; /* Disable scroll on the backdrop */
  cursor: default; /* Optional: Prevents pointer cursor on the backdrop */
`;

const ModalContent = styled.div`
  max-width: 80%;
  max-height: 80%;
  height: 100vh; 
  overflow: hidden;
`;

const EnlargedImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

const ImageGallery = ({ images }) => {
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'ArrowRight' && selectedImageIndex !== null) {
        // Right arrow key pressed
        if (selectedImageIndex < images.length - 1) {
          setSelectedImageIndex(selectedImageIndex + 1);
        } else {
          setSelectedImageIndex(0); // Loop back to the first image
        }
      } else if (event.key === 'ArrowLeft' && selectedImageIndex !== null) {
        // Left arrow key pressed
        if (selectedImageIndex > 0) {
          setSelectedImageIndex(selectedImageIndex - 1);
        } else {
          setSelectedImageIndex(images.length - 1); // Loop to the last image
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [selectedImageIndex, images]);

  const handleThumbnailClick = (idx) => {
    setSelectedImageIndex(idx);
  };

  const handleCloseModal = () => {
    setSelectedImageIndex(null);
  };

  const handleBackdropClick = (event) => {
    // Close the modal only if the click is on the backdrop itself, not on its children
    if (event.target === event.currentTarget) {
      handleCloseModal();
    }
  };

  useEffect(() => {
    // Disable scrolling on the body when the modal is open
    if (selectedImageIndex !== null) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    return () => {
      // Re-enable scrolling on the body when the modal is closed
      document.body.style.overflow = 'auto';
    };
  }, [selectedImageIndex]);

  return (
    <>
      <SubTitle>All Earned Certificates throughtout my learning journey</SubTitle>
      <ThumbnailContainer>
        {images.map((image, index) => (
          <ThumbnailImage
            key={index}
            src={image}
            alt={`Thumbnail ${index + 1}`}
            onClick={() => handleThumbnailClick(index)}
          />
        ))}
      </ThumbnailContainer>
      {selectedImageIndex !== null && (
        <ModalBackdrop onClick={handleBackdropClick}>
          <ModalContent>
            <EnlargedImage 
              src={images[selectedImageIndex]} 
              alt={`Enlarged Image: ${images[selectedImageIndex]}`} 
            />
          </ModalContent>
        </ModalBackdrop>
      )}
    </>
  );
};

export default ImageGallery;
